<script>


    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let rent;

    function back() {
        dispatch('back', {});
    }
</script>

<main class="flex flex-row w-full flex-wrap drogowskazFont h-full justify-evenly">

    <div class="flex flex-row w-full">
        <div class="h-full  w-2/4  flex flex-col bg-white text-center justify-center">
            <div>
                <br/>
            </div>
            <div>
                <img src="/logo.png"/>
            </div>
            <div>
                <br/>
            </div>
        </div>
        <div class="h-full w-2/4 flex flex-col bg-blue-1  text-center justify-center" on:click={back}>
            <div>
                <span class="text-2xl md:text-3xl"><i class="fas fa-arrow-left blue-3 mr-4"></i>Wstecz</span>
            </div>
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-4">
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <i class="fa fa-arrow-alt-circle-left fa-3x blue-3"></i>
        </div>
        <div class="w-3/4 text-center justify-center flex flex-col">
            <span class="text-xl">Początek:</span>
            <span class="text-3xl mt-4">
                <span>{rent.startDateDateStr}</span>  <span class="ml-6">{rent.startDateTimeStr}</span>
            </span>
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-4">
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <i class="fa fa-arrow-alt-circle-right fa-3x blue-2"></i>
        </div>
        <div class="w-3/4 text-center justify-center flex flex-col">
            <span class="text-xl">Koniec:</span>
            <span class="text-3xl mt-4">
                <span>{rent.endDateDateStr}</span>  <span class="ml-6">{rent.endDateTimeStr}</span>
            </span>
        </div>
    </div>

</main>
